import React, { useEffect } from 'react'

import RegisterForm from '../modules/register/Form'

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <RegisterForm />
  )
}
